const KEY = "stale_reload_at";
const STALE_RE = /ChunkLoadError|Loading (CSS )?chunk|Failed to fetch dynamically imported module|Unexpected token '<'|importing a module script failed/i;

export const isStaleError = (e) => STALE_RE.test(String(e?.message || e?.reason?.message || e?.reason || e || ""));

export function reloadOnceIfStale(e) {
  if (!isStaleError(e)) return false;
  const last = Number(sessionStorage.getItem(KEY) || 0);
  if (Date.now() - last < 30_000) return false;
  sessionStorage.setItem(KEY, String(Date.now()));
  window.location.reload();
  return true;
}

export function installStaleGuard() {
  window.addEventListener("error", (ev) => reloadOnceIfStale(ev.error || ev.message));
  window.addEventListener("unhandledrejection", (ev) => reloadOnceIfStale(ev.reason));
}
